import { EntityMetadataModel, PrimitiveType } from '../../../api/api';
import { SchemaRefModel } from '../Models/DomainServiceModel';
import { ObjectPropertyType } from '../Models/ObjectPropertyType';
import { SchemaValueModel } from '../Models/SchemaValueModel';
import { VariableScope } from '../Models/VariableScopes/VariableScope';
import { getEntityMetadataModelFromJsonSchema } from './EntityMetadataModelConverter';
import { IEntitySchemaRepository } from './EntitySchemaRepository';

function createObjectPropertyTypeFromSchema(schema: EntityMetadataModel | undefined, name: string): ObjectPropertyType {
	return {
		name: name,
		type: PrimitiveType.Object,
		isRequired: true,
		isMultiple: false,
		isComplex: true,
		referenceEntity: schema,
	};
}

async function addVariableObject(
	e: VariableScope,
	entitySchemaRepository: IEntitySchemaRepository,
	name: string,
	schemaRef: SchemaRefModel | undefined,
	schemaValue?: SchemaValueModel | undefined,
) {
	let schemaObject: ObjectPropertyType = createObjectPropertyTypeFromSchema(undefined, name);

	if (schemaRef) {
		const inputSchema = await entitySchemaRepository.getEntity(schemaRef);
		if (inputSchema) {
			schemaObject = createObjectPropertyTypeFromSchema(inputSchema, name);
		}
	}

	if (schemaValue?.Value) {
		const inputSchema = getEntityMetadataModelFromJsonSchema(schemaValue.Value);
		schemaObject = createObjectPropertyTypeFromSchema(inputSchema, name);
	}

	e.setVariable(name, schemaObject);
}

export async function createFlowVariableScope(
	inputSchemaRef: SchemaRefModel | undefined,
	outputSchemaRef: SchemaRefModel | undefined,
	inputSchemaValue: SchemaValueModel | undefined,
	outputSchemaValue: SchemaValueModel | undefined,
	entitySchemaRepository: IEntitySchemaRepository,
): Promise<VariableScope> {
	const e: VariableScope = new VariableScope();

	await addVariableObject(e, entitySchemaRepository, '$input', inputSchemaRef, inputSchemaValue);
	await addVariableObject(e, entitySchemaRepository, '$output', outputSchemaRef, outputSchemaValue);

	return e;
}
